import { Button, ButtonGroup, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import MROTextField from "../../../../../components/form_components/TextField";
import { fixedInputValueTo2DecimalPlaces } from "lib/utils/helperFunctions";

export default function NumericIncrementForWorkOrderLae({ setError, state, setState, ...props }) {
  const [val, setVal] = useState(props.value ? parseFloat(props?.value) : "");
  const handleChange = (action) => () => {
    typeof setError === "function" && setError();
    if (action === "inc") {
      if (parseFloat(val || 0) >= 0)
        if (parseFloat(val) % 0.5 === 0) setVal(parseFloat(val + 0.5));
        else setVal(parseFloat(val || 0) + 0.5);
    }
    if (action === "dec") {
      if (parseFloat(val) > 0)
        if (parseFloat(val) % 0.5 === 0){
          setVal(parseFloat(val - 0.5))
        } else if (parseFloat(val) <= 0.5 ){
          setVal(0)
        }
        else setVal(Math.round(parseFloat(val || 0) - 0.5))
    }
  };

  useEffect(() => {
    setState({
      ...state,
      lae_hrs: val,
    });
  }, [val]);

  console.log({ val });

  useEffect(() => {
    // setVal(parseFloat(props?.value))
  }, [props.value]);

  let inputprops = {
    value: props.value,
  };

  return (
    <>
      <Grid container alignItems="center">
        <Grid item xs={7}>
          <MROTextField
            {...props}
            defaultValue={val}
            onKeyPress={(e) => {
              const currentValue = e.target.value || "";
              if (!/[0-9.]/.test(e.key)) {
                e.preventDefault();
                return;
              }
              if (e.key === "." && currentValue.includes(".")) {
                e.preventDefault();
                return;
              }
              const dotIndex = currentValue.indexOf(".");
              if (dotIndex >= 0 && /[0-9]/.test(e.key) && currentValue.length - dotIndex > 2) {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              typeof setError === "function" && setError();
              let sanitized = e.target.value.replace(/[^0-9.]/g, "");
              const firstDot = sanitized.indexOf(".");
              if (firstDot >= 0) {
                sanitized = sanitized.slice(0, firstDot + 1) + sanitized.slice(firstDot + 1).replace(/\./g, "");
              }
              typeof setVal === "function" && setVal(fixedInputValueTo2DecimalPlaces(sanitized));
            }}
          />
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={4}>
          <ButtonGroup
            color="primary"
            aria-label="outlined primary button group"
          >
            <Button
              style={{ width: "46px", height: "36px" }}
              onClick={handleChange("dec")}
            >
              {" "}
              <RemoveIcon />
            </Button>
            <Button
              style={{ width: "46px", height: "36px" }}
              onClick={handleChange("inc")}
            >
              {" "}
              <AddIcon />
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
    </>
  );
}
